import { render, staticRenderFns } from "./directoryEdit.vue?vue&type=template&id=05096980&scoped=true&lang=html&"
import script from "./directoryEdit.vue?vue&type=script&lang=js&"
export * from "./directoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./directoryEdit.vue?vue&type=style&index=0&id=05096980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05096980",
  null
  
)

export default component.exports